export default __webpack_public_path__ + "static/media/abld_reading.bcada0c047c5812fc132e2e4a7e00d31.svg";